module.exports = __webpack_public_path__ + "static/media/btn_point_zbottom_pre.5c4d1ddb.svg";